import styled from "styled-components";

export const EditorContainer = styled.div`
  height: 100%;
  box-sizing: border-box;
  margin-inline: auto;
  margin-bottom: 96px;
  margin-top: 120px;
`;
